import { filterProps } from '../../../theming'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

export function extractStyleSystemProps(others) {
  const {
    m,
    mx,
    my,
    mt,
    mb,
    ml,
    mr,
    p,
    px,
    py,
    pt,
    pb,
    pl,
    pr,
    w,
    miw,
    maw,
    h,
    mih,
    mah,
    bg,
    c,
    fill,
    opacity,
    pos,
    top,
    left,
    bottom,
    right,
    display,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    alignContent,
    alignItems,
    alignSelf,
    flexDirection,
    justifyContent,
    flexWrap,
    order,
    gap,
    overflow,
    overflowX,
    overflowY,
    zIndex,
    ta,
    va,
    fontSize,
    fw,
    b,
    bs,
    bc,
    bw,
    btw,
    bbw,
    blw,
    brw,
    br,
    btr,
    bbr,
    btlr,
    btrr,
    bblr,
    bbrr,
    transition,
    transform,
    backgroundImage,
    backgroundSize,
    backgroundRepeat,
    backgroundPosition,
    objectFit,
    aspectRatio,
    outline,
    ...rest
  } = others;
  const styleSystemProps = filterProps({
    m,
    mx,
    my,
    mt,
    mb,
    ml,
    mr,
    p,
    px,
    py,
    pt,
    pb,
    pl,
    pr,
    w,
    miw,
    maw,
    h,
    mih,
    mah,
    bg,
    c,
    fill,
    opacity,
    pos,
    top,
    left,
    bottom,
    right,
    display,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    alignContent,
    alignItems,
    alignSelf,
    flexDirection,
    justifyContent,
    flexWrap,
    order,
    gap,
    overflow,
    overflowX,
    overflowY,
    zIndex,
    ta,
    va,
    fontSize,
    fw,
    b,
    bs,
    bc,
    bw,
    btw,
    bbw,
    blw,
    brw,
    br,
    btr,
    bbr,
    btlr,
    btrr,
    bblr,
    bbrr,
    transition,
    transform,
    backgroundImage,
    backgroundSize,
    backgroundRepeat,
    backgroundPosition,
    objectFit,
    aspectRatio,
    outline
  });
  return {
    styleSystemProps,
    rest: rest
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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